var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{class:[ 'site-loading', { 'activated': _vm.props.activated }],staticStyle:{"z-index":"100"}},[_vm._m(0)])}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"circle one"}),_vm._v(" "),_c('div',{staticClass:"circle two"})])}]

export { render, staticRenderFns }